<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>Layout Labelling</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8">
            <v-card class="pa-6">
              <v-card-title class="text-h5">Almost done. Tell us about your experience</v-card-title>
              <v-card-text>
                <p class="mb-6 text-body-1">
                  Your task answers are saved. Before you return to Prolific, please answer a few
                  quick questions about the study itself and yourself.
                </p>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  1. How clear were the instructions and the training video?
                </p>
                <v-btn-toggle v-model="clarity" class="mb-2" mandatory>
                  <v-btn v-for="n in 5" :key="'c'+n" :value="n" outlined color="primary">{{ n }}</v-btn>
                </v-btn-toggle>
                <p class="text-caption mb-6">1 means very unclear · 5 means very clear</p>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  2. Could you clearly see the two red target nodes and the dark rings around them
                  in every drawing?
                </p>
                <v-btn-toggle v-model="targets_visible" class="mb-6" mandatory>
                  <v-btn value="yes" outlined color="primary">Yes</v-btn>
                  <v-btn value="no" outlined color="primary">No</v-btn>
                </v-btn-toggle>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  3. Did you run into any technical problems (images not loading, buttons not
                  working, video issues)?
                </p>
                <v-textarea
                  v-model="technical_issues"
                  outlined
                  rows="2"
                  placeholder="Leave blank if none"
                  class="mb-4"
                ></v-textarea>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  4. Was anything confusing or frustrating? Anything we should improve?
                </p>
                <v-textarea
                  v-model="suggestions"
                  outlined
                  rows="2"
                  placeholder="Optional"
                  class="mb-6"
                ></v-textarea>

                <v-divider class="mb-6"></v-divider>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  5. What is the highest level of education you have completed?
                </p>
                <v-radio-group v-model="education_level" class="mb-6 mt-0">
                  <v-radio
                    v-for="opt in educationOptions"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  ></v-radio>
                </v-radio-group>

                <p class="text-subtitle-1 font-weight-medium mb-2">
                  6. How often do you work with diagrams that show connections between items
                  (e.g., network diagrams, org charts, mind maps, flowcharts)?
                </p>
                <v-radio-group v-model="diagram_frequency" class="mb-2 mt-0">
                  <v-radio
                    v-for="opt in frequencyOptions"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  large
                  :disabled="!canSubmit"
                  :loading="loading"
                  @click="submit"
                >
                  Submit and continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'PostStudy',
  title: 'Post-Study',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      clarity: null,
      targets_visible: null,
      technical_issues: '',
      suggestions: '',
      education_level: null,
      diagram_frequency: null,
      loading: false,
      educationOptions: [
        'Some high school',
        'High school diploma or GED',
        'Some college, no degree',
        'Associate degree',
        "Bachelor's degree",
        "Master's degree",
        'Doctoral or professional degree',
        'Prefer not to say',
      ],
      frequencyOptions: [
        'Never',
        'Rarely',
        'Sometimes',
        'Often',
        'Very often',
      ],
    };
  },
  computed: {
    canSubmit() {
      return this.clarity && this.targets_visible && this.education_level && this.diagram_frequency;
    },
  },
  methods: {
    async submit() {
      if (!this.canSubmit || this.loading) return;
      this.loading = true;
      try {
        await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/post_study/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            responses: {
              clarity: this.clarity,
              targets_visible: this.targets_visible,
              technical_issues: (this.technical_issues || '').trim(),
              suggestions: (this.suggestions || '').trim(),
              education_level: this.education_level,
              diagram_frequency: this.diagram_frequency,
            },
          }),
        });
        this.$router.push(`/prolific/study/${this.sessionId}/finish`);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
